import { Component, Input } from '@angular/core';
import { HvtSection5ContactDto } from '../../../models/notices/ojeu.notice.models';

@Component({
    selector: 'hvt-s5-contact',
    template: require('./hvt.section.5.contact.component.html')
})
export class HvtSection5ContactComponent {
    @Input() contact: HvtSection5ContactDto;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/notices/ojeu/hvt.section.5.contact.component.ts